import { render, staticRenderFns } from "./MainApplication.vue?vue&type=template&id=509bfaba&"
import script from "./MainApplication.vue?vue&type=script&lang=js&"
export * from "./MainApplication.vue?vue&type=script&lang=js&"
import style0 from "./MainApplication.vue?vue&type=style&index=0&id=509bfaba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports